import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  Button,
  Text,
} from '@chakra-ui/react';
import { ReactElement, memo, useRef } from 'react';
import { useTranslation } from 'react-i18next';

interface DeleteAlertDialogProps {
  title: string | ReactElement;
  message: string;
  isOpen: boolean;
  onClose: () => void;
  onDelete: () => void;
}

const DeleteAlertDialog = memo(({ isOpen, onClose, onDelete, title, message }: DeleteAlertDialogProps) => {
  const cancelRef = useRef<HTMLButtonElement>(null);
  const { t } = useTranslation('editor_widget_menu', { useSuspense: false, keyPrefix: 'sideMenu.imagesMenu.folders' });

  /**
   * handle the onDelete action and close the modal
   */
  const handleDelete = async () => {
    onDelete();
    onClose();
  };

  return (
    <AlertDialog isOpen={isOpen} leastDestructiveRef={cancelRef} onClose={onClose} isCentered>
      <AlertDialogOverlay bg='blackAlpha.500'>
        <AlertDialogContent>
          <AlertDialogHeader fontSize='lg' fontWeight='bold' as='h4'>
            {title}
          </AlertDialogHeader>
          <AlertDialogBody>
            <Text as='span'>{message}</Text>
          </AlertDialogBody>
          <AlertDialogFooter>
            <Button size='sm' variant='ghost' ref={cancelRef} onClick={onClose}>
              {t('cancel')}
            </Button>
            <Button size='sm' colorScheme='red' onClick={handleDelete} ml={3}>
              {t('delete')}
            </Button>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialogOverlay>
    </AlertDialog>
  );
});

DeleteAlertDialog.displayName = 'DeleteAlertDialog';

export default DeleteAlertDialog;
